import { IFileResponse } from "../pages/files/type/file";
import { getUser } from "../services/auth";

/**
 * Utility function to check if the current user can access a specific file
 * based on client category and user role
 *
 * @param file The file data
 * @returns boolean indicating if the user can access the file
 */
export const canUserAccessFile = (file: IFileResponse): boolean => {
  const user = getUser();
  const role = user.role;
  const userId = user.id;

  if (role !== "client") {
    // Admin, branch admin, lawyer, staff can access all files
    return true;
  }

  const clientCategory = file.clientCategory;

  if (clientCategory === "both") {
    // If client category is "both", all users can access
    return true;
  } else if (clientCategory === "vendor") {
    // If client category is "vendor", only vendor user can access
    return file.vendor?.id === userId;
  } else if (clientCategory === "purchaser") {
    // If client category is "purchaser", only purchaser user can access
    return file.purchaser?.id === userId;
  }

  return false;
};
